import { initialState } from "./state"
export default {
  updateCurrentStep: (state, payload) => (state.currentStep = payload),
  updateVisitFlow: (state, payload) => (state.visitFlow = { ...state.visitFlow, ...payload }),
  updateLoading: (state, payload) => (state.loading = {...state.loading, ...payload}),
  updateIsEditing: (state, payload) => (state.isEditing = payload),
  updateUuid: (state, payload) => (state.uuid = payload),
  fillVisitFlow: (state, payload) => (state.visitFlow = payload),
  resetVisitFlow: state => {
    const init_state = initialState()
    Object.keys(state).forEach(key => {
      state[key] = init_state[key]
    })
  }
}